export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/papers.b39d4746.svg","height":166,"width":351,"blurWidth":0,"blurHeight":0};